<template>
  <div class="eInvoice">
    <banner clazz="eInvoice-banner" url="eInvoice">
      <template slot="buttons">
        <el-button class="banner-button" round @click="this.goConsult">立即咨询</el-button>
        <el-button class="banner-button" round @click="goRegister(1)">申请体验</el-button>
      </template>
    </banner>
    <div class="eInvoice-list1">
      <div class="tc container">
        <h1 class="title">为什么越来越多的企业，使用电子发票？</h1>
        <div class="dib border-bottom"></div>
        <p class="eInvoice-list1-desc">纸质发票邮寄和重开是一个手动繁重的过程，成本高，效率低，错误和延迟很普遍，导致付款延迟，电子发票可以迅速解决这些问题。</p>
        <div class="clearfix eInvoice-item">
          <div class="fl item">
            <img src="../../assets/img/eInvoice/icon01.png" alt="自动化您的发票流程">
            <h1 class="item-title">自动化您的发票流程</h1>
            <p class="item-desc">摆脱纸质发票邮寄，人为错误造成的重开，实现未付款项的可见性，减轻财务团队的负担</p>
          </div>
          <div class="fl item">
            <img src="../../assets/img/eInvoice/icon02.png" alt="便于全球业务开展">
            <h1 class="item-title">便于全球业务开展</h1>
            <p class="item-desc">
              电子发票可广泛应用于本地和全球，内置增值税/税务发票识别+验证解决方案，便于业务全球开展
            </p>
          </div>
          <div class="fl item">
            <img src="../../assets/img/eInvoice/icon03.png" alt="增加您的营运资金">
            <h1 class="item-title">增加您的营运资金</h1>
            <p class="item-desc">
              通过减少发票处理时间，获得提前付款折扣，优化公司运营现金流。
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="eInvoice-list2">
      <div class="item-list">
        <div class="tc">
          <h1 class="item-list-title">我们的电子发票将变革您的发票管理</h1>
          <div class="dib tl border-bottom"></div>
        </div>
        <div class="item-tab">
          <el-tabs type="border-card" stretch>
            <el-tab-pane label="电子发票">
              <div class="rel clearfix content">
                <div class="fl left-list">
                  <h1 class="title">精确定位，加速发票处理</h1>
                  <div class="border-bottom-tab"></div>
                  <div class="left-img">
                    <img src="../../assets/img/eInvoice/img1.png" alt="精确定位，加速发票处理">
                  </div>
                </div>
                <div class="fr rel right-list">
                  <div class="right-img">
                    <img src="../../assets/img/eInvoice/peitu-1.png" alt="精确定位，加速发票处理">
                  </div>
                  <div class="abs right-bg rbg01"></div>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="发票OCR">
              <div class="clearfix content">
                <div class="fl left-list">
                  <h1 class="title">增值税发票识别+验真</h1>
                  <div class="border-bottom-tab"></div>
                  <p class="left-desc">
                    扫描并对供应商提供的纸质文档分析和处理，获取发票代码、发票号码、开票日期、 开票金额、纳税人编号等字段，并将识别的数据信息，传到公司的数据系统或业务流程系统。
                  </p>
                </div>
                <div class="fr rel right-list">
                  <div class="right-img">
                    <img src="../../assets/img/eInvoice/peitu-2.png" alt="增值税发票识别+验真">
                  </div>
                  <div class="abs right-bg rbg02"></div>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="自动对账">
              <div class="clearfix content">
                <div class="fl left-list">
                  <h1 class="title">提高处理效率，规避人为错误</h1>
                  <div class="border-bottom-tab"></div>
                  <p class="left-desc">
                    自动执行发票对账流程，以消除错误，降低风险并减轻应付账款团队负担，实现更好的战略洞察。
                  </p>
                </div>
                <div class="fr rel right-list">
                  <div class="right-img">
                    <img src="../../assets/img/eInvoice/peitu-3.png" alt="提高处理效率，规避人为错误">
                  </div>
                  <div class="abs right-bg rbg03"></div>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="重开发票">
              <div class="clearfix content">
                <div class="fl left-list">
                  <h1 class="title">透明且更接近现实成本</h1>
                  <div class="border-bottom-tab"></div>
                  <p class="left-desc">
                    根据所消耗的服务，每个月或每年结束每个业务部门的发票。因此，所有投资和运营成本都与公司的业务直接相关并且具有价值。
                  </p>
                  <div class="left-link">
                    <div class="left-link-item">
                      <span></span>
                      根据公认的成本重新开票
                    </div>
                    <div class="left-link-item">
                      <span></span>
                      关闭发票的重新开票（可能在申请时进入）
                    </div>
                    <div class="left-link-item">
                      <span></span>
                      在内部时间表（内部CRA）上重新开票
                    </div>
                  </div>
                </div>
                <div class="fr rel right-list">
                  <div class="right-img">
                    <img src="../../assets/img/eInvoice/peitu-4.png" alt="在内部时间表（内部CRA）上重新开票">
                  </div>
                  <div class="abs right-bg rbg04"></div>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="AP自动化">
              <div class="clearfix content">
                <div class="fl left-list">
                  <h1 class="title">实时效率</h1>
                  <div class="border-bottom-tab"></div>
                  <p class="left-desc">
                    通过与ERP和其他会计系统的无缝集成，AP Automation在采购过程中生成应计和A /
                    P条目。这种实时报告可以节省大量时间，并确保发票付款对帐流程的准确性。应计，预付费用，负债和发票条目的条目/工作流程的自动设置可减少错误并增强协作。
                  </p>
                </div>
                <div class="fr rel right-list">
                  <div class="right-img">
                    <img src="../../assets/img/eInvoice/peitu-5.png" alt="通过与ERP和其他会计系统的无缝集成">
                  </div>
                  <div class="abs right-bg rbg05"></div>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
      <div class="item-list2"></div>
    </div>
  </div>
</template>

<script>
import banner from '../common/banner.vue'

export default {
  inject: ['openRegister', 'goConsult'],
  name: 'Einvoice',
  metaInfo () {
    return {
      title: this.$seo.einvoice.title, // set a title
      meta: [{ // set meta
        name: 'keywords',
        content: this.$seo.einvoice.keywords
      },
      {
        name: 'description',
        content: this.$seo.einvoice.description
      }]
    }
  },
  components: {
    banner
  },
  data () {
    return {}
  },
  methods: {
    goRegister (code) {
      this.openRegister(false, code)
    }
  },
  created () {
  }
}
</script>

<style lang="scss">
  @import '../../../static/css/eInvoice.scss';
</style>



// WEBPACK FOOTER //
// eInvoice.vue?221b24b6